module.exports = __webpack_public_path__ + "static/media/21.333071fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/21.png
// module id = 1127
// module chunks = 0